import { ReactNode } from "react"
import { Container, Flex } from "@chakra-ui/react"

import { LANDING_CONTAINER_WIDTH } from "#/shared/constants"
import { useDAppRoute, useHodlRoute, useLandingRoute } from "#/shared/hooks"

export default function HeaderWrapper({ children }: { children: ReactNode }) {
  const isDAppRoute = useDAppRoute()
  const isHodlRoute = useHodlRoute()
  const { isLandingRoute } = useLandingRoute()

  return (
    <Container
      pos={isLandingRoute ? "relative" : "fixed"}
      top={0}
      h="84px"
      left={0}
      pl={6}
      pr={10}
      minW="100%"
      // Adjust the z-index to be lower than 89, which is the current setting
      // for the WalletConnect modal, to ensure proper layering.
      zIndex={88}
      bg={isLandingRoute ? "transparent" : "primary.white.100"}
      borderBottomWidth={
        isLandingRoute || isHodlRoute || !isDAppRoute ? 0 : "1px"
      }
      borderStyle="solid"
      borderColor="primary.black.10"
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        w="100%"
        gap="232px"
        maxW={isLandingRoute ? LANDING_CONTAINER_WIDTH : "100%"}
        margin="auto"
        h="100%"
      >
        {children}
      </Flex>
    </Container>
  )
}
